export default "__VITE_ASSET__cca45f87__"